__turbopack_context__.v({
  "loader": "_85S58G_loader",
  "spin": "_85S58G_spin",
});
